export default {
    API_HOST: 'http://207.154.220.54:9002'
};